export const BLOCK_PREVIEW = 'preview-text';
export const BLOCK_TEXT = 'text';
export const BLOCK_PICTURE = 'text-under-picture';
